import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DropZone,
  Stack,
  FormLayout,
  // TextField,
  Thumbnail,
  Checkbox,
  Toast,
  Button,
  Text,
  TextContainer,
  Modal,
  Select,
  ButtonGroup,
  Icon,
  Popover,
  ActionList,
  TextField,
  Tooltip,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import {
  LanguageMinor,
  MobileVerticalDotsMajor,
  SearchMinor,
  ColorsMajor,
} from "@shopify/polaris-icons";
import Instruction from "./Instruction";
import SelectSearch from "react-select-search";
import Autocomplete from "@mui/material/Autocomplete";
import { StyledEngineProvider } from "@mui/material/styles";
import { TextField as TextField2 } from "@mui/material";
import { accessEditSections } from "../Helpers";
import axiosDefault from "axios";
import LoadingScreen from "./LoadingScreen";
import AsyncSelect from "react-select/async";
import instructionImg from "../Assets/Images/instruction-help.svg";

const CustomBlockSection = (props) => {
  // console.log("lklk==", props);
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);
  let object = JSON.parse(props.object);
  const [data, setData] = useState([]);
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeType = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, type: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeAlias = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, alias: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLink = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeType2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, type2: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLink2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLink2: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTypeTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, type: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeAliasTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, alias: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLinkTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeTypeTranslated2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, type2: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLinkTranslated2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaLink2: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, gifs and jsons"}
    />
  );
  const uploadedFile = file && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "banner");
    form_data.append("image[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              image:
                validImageTypes.indexOf(file[file.length - 1].type) > 0
                  ? window.URL.createObjectURL(file[file.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
              fileImage: imageKey.current,
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMobile, setFileMobile] = useState();
  const handleDropZoneDropMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMobile((fileMobile) => acceptedFiles[0]),
    []
  );
  const fileUploadMobile = !fileMobile && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, gifs and jsons"}
    />
  );
  const uploadedFileMobile = fileMobile && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={fileMobile.name}
        source={
          validImageTypes.includes(fileMobile.type)
            ? window.URL.createObjectURL(fileMobile)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMobile.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageMobile = (fileMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "banner");
    form_data.append(`mobile_image[en]`, fileMobile[fileMobile.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              mobileImage:
                validImageTypes.indexOf(
                  fileMobile[fileMobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMobile[fileMobile.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
              fileMobileImage: imageKey.current,
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  ///

  const [fileTranslated, setFileTranslated] = useState();
  const handleDropZoneDropTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslated((fileTranslated) => acceptedFiles[0]),
    []
  );
  const fileUploadTranslated = !fileTranslated && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, gifs and jsons"}
    />
  );
  const uploadedFileTranslated = fileTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageTranslated = (fileTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "banner");
    form_data.append(
      `image[${selectedLanguage}]`,
      fileTranslated[fileTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              image:
                validImageTypes.indexOf(
                  fileTranslated[fileTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslated[fileTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
              fileImage: imageKey.current,
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMobileTranslated, setFileMobileTranslated] = useState();
  const handleDropZoneDropMobileTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMobileTranslated((fileMobileTranslated) => acceptedFiles[0]),
    []
  );
  const fileUploadMobileTranslated = !fileMobileTranslated && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs, gifs and jsons"}
    />
  );
  const uploadedFileMobileTranslated = fileMobileTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={fileMobile.name}
        source={
          validImageTypes.includes(fileMobile.type)
            ? window.URL.createObjectURL(fileMobile)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMobileTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMobileTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageMobileTranslated = (fileMobileTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "banner");
    form_data.append(
      `mobile_image[${selectedLanguage}]`,
      fileMobileTranslated[fileMobileTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              mobileImage:
                validImageTypes.indexOf(
                  fileMobileTranslated[fileMobileTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMobileTranslated[fileMobileTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
              fileMobileImage: imageKey.current,
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  // async function fetchShopifyCollections() {
  //   try {
  //     let responseShopifyCollection = "";
  //     responseShopifyCollection = await axios.get(
  //       selectedCtaLinkType === "2"
  //         ? `/shopify-products/search?param=${inputValueCollection}`
  //         : `/shopify-collections/search?param=${inputValueCollection}`
  //     );

  //     responseShopifyCollection?.data?.data &&
  //       setOptionsCollections(
  //         responseShopifyCollection.data.data.map((item, index) => {
  //           return {
  //             key: item.id,
  //             label: item.title,
  //             value: item.handle,
  //           };
  //         })
  //       );
  //   } catch (error) {}
  // }
  const handleChangeTemplate = (newValue) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, template: newValue };
      }
      return obj;
    });
    setData(newState);
  };
  useEffect(() => {
    !props.shopifyDomainFound &&
      setOptionsCtaLinkType(
        optionsCtaLinkType.filter(
          (item) =>
            item.label !== "Shopify Product" &&
            item.label !== "Shopify Collection"
        )
      );
    object = JSON.parse(props.object);
    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            instruction: object?.instructions ? object?.instructions : "",
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            subtitle:
              object?.subtitle && object?.subtitle[element.value]
                ? object?.subtitle[element.value]
                : "",
            text:
              object?.details?.source_code &&
              object?.details?.source_code[element.value]
                ? object?.details?.source_code[element.value]
                : "",
            type:
              object?.details?.type && object?.details?.type[element.value]
                ? object?.details?.type[element.value]
                : "",
            alias:
              object?.details?.alias && object?.details?.alias[element.value]
                ? object?.details?.alias[element.value]
                : "",
            active: object?.details?.is_active ? true : false,

            template:
              object?.template_id !== null
                ? String(object?.template_id)
                : props.templates[0]?.id
                ? props.templates[0]?.id
                : "",
          };
        })
    );
  }, [props.object]);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    []
  );
  const activator = (
    <Button onClick={togglePopoverActive} plain>
      <Icon source={MobileVerticalDotsMajor} />
    </Button>
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This image have been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDeleteImage = (field, language) => {
    refId.current = field + ";" + language;
    setActiveDelete(true);
  };

  const handleYesDelete = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("entity_type", "section");
    form_data.append("entity_id", props.sectionId);
    form_data.append("field", refId.current.split(";")[0]);
    form_data.append("language_code", refId.current.split(";")[1]);
    axios
      .post(`/remove/image`, form_data)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        const newState = data.map((obj) => {
          if (obj.language === refId.current.split(";")[1]) {
            if (refId.current.split(";")[0] === "image")
              return {
                ...obj,
                image: "",
              };
            else
              return {
                ...obj,
                mobileImage: "",
              };
          }
          return obj;
        });
        setData(newState);
      })
      .catch((err) => console.log(err));
  };
  const [selectedCtaLinkType, setSelectedCtaLinkType] = useState("");
  const handleSelectChangeCtaLinkType = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkType: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const handleSelectChangeCtaLinkType2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkType2: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [optionsCtaLinkType, setOptionsCtaLinkType] = useState([
    { label: "External Link", value: "1" },
    { label: "Page", value: "2" },
    { label: "Blog", value: "3" },
    { label: "Shopify Product", value: "4" },
    { label: "Shopify Collection", value: "5" },
  ]);

  const [selectedPage, setSelectedPage] = useState("");
  const handleSelectChangePage = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkPage: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const handleSelectChangeBlog = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkBlog: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const handleSelectChangeBlog2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkBlog2: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedPage2, setSelectedPage2] = useState("");
  const handleSelectChangePage2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkPage2: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [optionsCollections, setOptionsCollections] = useState([]);
  const [selectedShopifyCollection, setSelectedShopifyCollection] =
    useState("");
  const handleSelectChangeShopifyCollection = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkCollection: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyCollection2, setSelectedShopifyCollection2] =
    useState("");
  const handleSelectChangeShopifyCollection2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkCollection2: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [optionsProducts, setOptionsProducts] = useState([]);
  const [selectedShopifyProduct, setSelectedShopifyProduct] = useState("");
  const handleSelectChangeShopifyProduct = (value) => {
    console.log(value);
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkProduct: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyProduct2, setSelectedShopifyProduct2] = useState("");
  const handleSelectChangeShopifyProduct2 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkProduct2: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);
  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const [firstTimeLoadedProductsOptions, setFirstTimeLoadedProductsOptions] =
    useState([]);
  const loadOptionsProducts = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const [
    firstTimeLoadedCollectionsOptions2,
    setFirstTimeLoadedCollectionsOptions2,
  ] = useState([]);

  const loadOptionsCollections2 = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions2(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const [firstTimeLoadedProductsOptions2, setFirstTimeLoadedProductsOptions2] =
    useState([]);
  const loadOptionsProducts2 = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions2(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  return (
    <FormLayout>
      {/* <Instruction
        text={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").instruction
        }
        pageId={id}
        sectionId={props.sectionId}
        handleRefreshSections={props.handleRefreshSections}
      /> */}
      <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageMinor : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
          {/* <Button
            plain
            onClick={() => props.handleCustomizeStyles()}
            icon={ColorsMajor}
          >
            Customize Styles
          </Button> */}
        </ButtonGroup>
      </div>
      <div style={{ overflow: "auto", minWidth: "100%" }}>
        <table>
          <tbody>
            <tr>
              <th>
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
              </th>
              <th>
                <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
              </th>
              {translatedButtonClicked && (
                <th>
                  <Select
                    // helpText="Please select a language before you fill data"
                    options={props.languagesArray}
                    onChange={handleSelectChangeLanguage}
                    value={selectedLanguage}
                    placeholder="Please select a language"
                  />
                </th>
              )}
            </tr>
            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  Title
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").title
                  }
                  onChange={handleChangeTitle}
                  disabled={translatedButtonClicked}
                />
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).title
                    }
                    onChange={handleChangeTitleTranslated}
                  />
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  Subtitle
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").subtitle
                  }
                  onChange={handleChangeSubtitle}
                  disabled={translatedButtonClicked}
                />
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage)
                        .subtitle
                    }
                    onChange={handleChangeSubtitleTranslated}
                  />
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  Type
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").type
                  }
                  onChange={handleChangeType}
                  disabled={translatedButtonClicked}
                />
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).type
                    }
                    onChange={handleChangeTypeTranslated}
                  />
                </td>
              )}
            </tr>

            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  Alias
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").alias
                  }
                  onChange={handleChangeAlias}
                  disabled={translatedButtonClicked}
                />
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).alias
                    }
                    onChange={handleChangeAliasTranslated}
                  />
                </td>
              )}
            </tr>
            <tr>
              <td>
                <Text variant="bodyMd" as="p" color="subdued">
                  Source code
                </Text>
              </td>
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").text
                  }
                  onChange={handleChangeText}
                  disabled={translatedButtonClicked}
                  multiline={6}
                />
              </td>
              {translatedButtonClicked && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).text
                    }
                    onChange={handleChangeTextTranslated}
                    multiline={6}
                  />
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>

      {/* <FormLayout.Group>
        <FormLayout>
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Desktop Image
          </Text>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <div style={{ float: "left" }}>
              <Thumbnail
                size="large"
                source={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").image
                    ? findArrayElementByLanguage(data, "en").image
                    : ""
                }
              />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpeg,.jpg,.svg,.json"
                //   type="file"
                allowMultiple={false}
                onDrop={handleDropZoneDrop}
                onDropAccepted={sendImage}
              >
                {uploadedFile}
                {fileUpload}
              </DropZone>
            </div>
          </div>
        </FormLayout>
        <FormLayout>
          <Text variant="bodyMd" as="p" fontWeight="medium">
            Mobile Image
          </Text>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
            }}
          >
            <div style={{ float: "left" }}>
              <Thumbnail
                size="large"
                source={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").mobileImage
                    ? findArrayElementByLanguage(data, "en").mobileImage
                    : ""
                }
              />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpeg,.jpg,.svg,.json"
                //   type="file"
                allowMultiple={false}
                onDrop={handleDropZoneDropMobile}
                onDropAccepted={sendImageMobile}
              >
                {uploadedFileMobile}
                {fileUploadMobile}
              </DropZone>
            </div>
          </div>
        </FormLayout>
      </FormLayout.Group> */}
      <Text>Template: </Text>
      <div className="boxTemplates">
        {props.templates?.length ? (
          props.templates.map((item, index) => {
            return (
              <div
                style={{ marginRight: "1rem" }}
                key={item.id}
                onClick={() => handleChangeTemplate(item.id)}
                className={`divTemplate ${
                  findArrayElementByLanguage(data, "en")
                    ? String(
                        findArrayElementByLanguage(data, "en").template
                      ) === String(item.id) && "borderTemplate"
                    : ""
                }`}
              >
                {item.text && (
                  <div className="templateInstruction">
                    <Tooltip content={item.text}>
                      <img
                        src={instructionImg}
                        width={17}
                        className="templateInstruction"
                      />
                    </Tooltip>
                  </div>
                )}

                <div className="buttonTemplate">
                  {item.image && <img src={item.image} width={30}></img>}
                  <div style={{ marginTop: "0.2rem" }}>
                    <Text color="subdued">{item.description}</Text>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <Text color="subdued">No templates added for this section type</Text>
        )}
      </div>

      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <FormLayout.Group>
        {/* <Button
          primary
          onClick={() => {
            props.handleSavingState();
            axios
              .delete(`/pages/${id}/sections/${props.sectionId}`)
              .then((result) => {
                props.handleDeleteAndRefresh();
              })
              .catch((err) => console.log(err));
          }}
          loading={props.isSaving}
          destructive
          fullWidth
        >
          Delete
        </Button> */}
        <div style={{ float: "right" }}>
          <Button
            primary
            onClick={handleSave}
            loading={props.isSaving}
            disabled={!accessEditSections()}
          >
            Save
          </Button>
        </div>
      </FormLayout.Group>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Image"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this image?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </FormLayout>
  );
  function handleSave() {
    props.handleSavingState();
    const form_data = new FormData();
    findArrayElementByLanguage(data, "en") &&
      (findArrayElementByLanguage(data, "en").template === "none"
        ? form_data.append(`template_id`, "")
        : form_data.append(
            `template_id`,
            findArrayElementByLanguage(data, "en").template
          ));

    data.forEach((selected, index) =>
      form_data.append(`title[${selected.language}]`, selected.title)
    );

    data.forEach((selected, index) =>
      form_data.append(`source_code[${selected.language}]`, selected.text)
    );
    data.forEach((selected, index) =>
      form_data.append(`alias[${selected.language}]`, selected.alias)
    );
    data.forEach((selected, index) =>
      form_data.append(`type[${selected.language}]`, selected.type)
    );
    data.forEach((selected, index) =>
      form_data.append(`subtitle[${selected.language}]`, selected.subtitle)
    );

    form_data.append("is_active", data[data.length - 1].active ? 1 : 0);

    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    form_data.append("_method", "PATCH");
    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch(function (error) {
        if (error.response) {
          setToastContent(error.response.data.message);
          toggleActive();
          props.handleResetSavingState();
        }
      });
  }
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
};
export default CustomBlockSection;
